var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ferry-driver-select-wrapper" },
    [
      _vm.label
        ? _c("div", { staticClass: "ferry-driver-select-label" }, [
            _vm.required
              ? _c("span", { staticClass: "required-asterisk" }, [_vm._v("*")])
              : _vm._e(),
            _vm._v("\n    " + _vm._s(_vm.label) + "\n  "),
          ])
        : _vm._e(),
      _c(
        "el-popover",
        {
          attrs: {
            placement: "bottom-start",
            trigger: "manual",
            width: _vm.width || 420,
            "popper-class": "ferry-driver-select-popover",
          },
          model: {
            value: _vm.popoverVisible,
            callback: function ($$v) {
              _vm.popoverVisible = $$v
            },
            expression: "popoverVisible",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "ferry-driver-select-container",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "search-box" },
                [
                  _c(
                    "el-input",
                    {
                      attrs: {
                        placeholder: "请输入司机姓名",
                        size: "small",
                        clearable: "",
                        "prefix-icon": "el-icon-search",
                      },
                      model: {
                        value: _vm.searchKeyword,
                        callback: function ($$v) {
                          _vm.searchKeyword = $$v
                        },
                        expression: "searchKeyword",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            slot: "append",
                            type: "primary",
                            size: "small",
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.handleSearch.apply(null, arguments)
                            },
                          },
                          slot: "append",
                        },
                        [_vm._v("\n            搜索\n          ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticClass: "ferry-driver-list",
                },
                [
                  _vm.ferryDriverList.length
                    ? _c("RecycleScroller", {
                        attrs: {
                          items: _vm.ferryDriverList,
                          "item-size": 50,
                          emitUpdate: true,
                          "key-field": "driverId",
                        },
                        on: { scroll: _vm.scroll },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var item = ref.item
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "ferry-driver-item",
                                      class: {
                                        selected: _vm.isItemSelected(item),
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.handleSelectItem(item)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "ferry-driver-item-content",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "item-name" },
                                            [_vm._v(_vm._s(item.driverInfo))]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4030754818
                        ),
                      })
                    : _vm._e(),
                  _vm.ferryDriverList.length === 0 && !_vm.loading
                    ? _c("div", { staticClass: "empty-data" }, [
                        _vm._v("暂无数据"),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "reference-input",
              attrs: { slot: "reference" },
              slot: "reference",
            },
            [
              _c("el-input", {
                attrs: {
                  placeholder: _vm.placeholder || "请选择摆渡司机",
                  size: "small",
                  readonly: "",
                  "suffix-icon": "el-icon-arrow-down",
                },
                nativeOn: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.togglePopover($event)
                  },
                },
                model: {
                  value: _vm.displayValue,
                  callback: function ($$v) {
                    _vm.displayValue = $$v
                  },
                  expression: "displayValue",
                },
              }),
              _vm.selectedItems.length > 0 && !_vm.displayValue
                ? _c(
                    "div",
                    { staticClass: "selected-tags" },
                    [
                      _vm.collapseTags &&
                      _vm.selectedItems.length > _vm.collapseTagsLimit
                        ? [
                            _vm._l(
                              _vm.selectedItems.slice(0, _vm.collapseTagsLimit),
                              function (item) {
                                return _c(
                                  "el-tag",
                                  {
                                    key: item.driverId,
                                    attrs: { size: "small", closable: "" },
                                    on: {
                                      close: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.removeItem(item)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(item.name) +
                                        "\n          "
                                    ),
                                  ]
                                )
                              }
                            ),
                            _c(
                              "el-tag",
                              {
                                staticClass: "collapse-tag",
                                attrs: { size: "small", type: "info" },
                              },
                              [
                                _vm._v(
                                  "\n            +" +
                                    _vm._s(
                                      _vm.selectedItems.length -
                                        _vm.collapseTagsLimit
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ]
                        : _vm._l(_vm.selectedItems, function (item) {
                            return _c(
                              "el-tag",
                              {
                                key: item.driverId,
                                attrs: { size: "small", closable: "" },
                                on: {
                                  close: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.removeItem(item)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(item.name) +
                                    "\n          "
                                ),
                              ]
                            )
                          }),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }